import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ng-casto-offer-coupon-card',
  templateUrl: './offer-coupon-card.component.html',
})
export class OfferCouponCardComponent {
  @Input() title: string | null = '';
  @Input() expirationDate: Date | null = undefined;

  private readonly dateFormat: string = 'dd/MM/yyyy';

  get formatedExpirationDate() {
    let datePipe = new DatePipe('fr-FR');
    return datePipe.transform(this.expirationDate, this.dateFormat);
  }
}
